"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExceptionType = exports.MessageType = void 0;
var MessageType;
(function (MessageType) {
    MessageType[MessageType["Input"] = 0] = "Input";
    MessageType[MessageType["Exception"] = 1] = "Exception";
    MessageType[MessageType["WaitOn"] = 2] = "WaitOn";
    MessageType[MessageType["StopAndFilterWorkflow"] = 3] = "StopAndFilterWorkflow";
})(MessageType = exports.MessageType || (exports.MessageType = {}));
var ExceptionType;
(function (ExceptionType) {
    ExceptionType[ExceptionType["Unknown"] = 0] = "Unknown";
    ExceptionType[ExceptionType["NoOutput"] = 1] = "NoOutput";
    ExceptionType[ExceptionType["Authentication"] = 2] = "Authentication";
    ExceptionType[ExceptionType["JoinTimedOut"] = 3] = "JoinTimedOut";
    ExceptionType[ExceptionType["LambdaThrow"] = 4] = "LambdaThrow";
    ExceptionType[ExceptionType["LambdaErrorCallback"] = 5] = "LambdaErrorCallback";
})(ExceptionType = exports.ExceptionType || (exports.ExceptionType = {}));
//# sourceMappingURL=message-schema.js.map